import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CONTACT_US_URL } from '../../utils/constants';

import PropTypes from 'prop-types';

const SnackBarMessage = ({ title, message }) => {
  return (
    <div className="error-snackbar-message">
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {title || 'Sorry, something went wrong...'}
      </Typography>
      {message && <p>Error: {message}</p>}
      <p>
        Please refresh to try again.
        <br />
        If you continue to have issues, please{' '}
        <a href={CONTACT_US_URL} target="_blank" rel="noopener noreferrer">
          contact us
        </a>
        .
      </p>
    </div>
  );
};

SnackBarMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

const ErrorSnackbar = ({ title, message, isOpen, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={isOpen}
      onClose={onClose}
      message={<SnackBarMessage title={title} message={message} />}
      autoHideDuration={10000}
      sx={{
        '& .MuiSnackbarContent-root': {
          backgroundColor: 'red', // Custom background color
          color: 'white', // Custom text color
          alignItems: 'start',
        },
      }}
      action={
        <IconButton aria-label="close" color="inherit" sx={{ p: 0.5 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      }
    />
  );
};

ErrorSnackbar.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorSnackbar;
